@use "sass:map";
@import "../../../globalStyles/commons";


:host {
  display: block;
  height: 100%;
}

.editor-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: v(--spacing-02);
}

.code-editor-component {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid v(--border-strong);
  border-radius: v(--border-radius);
  background-color: var(--input-background-color, var(--field));

  .tabs-list {
    border-top: 1px solid v(--border-strong);
  }

  .wysiwyg-container {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    color: v(--text-primary);




    .toolbar {
      display: flex;
      border-bottom: 1px solid var(--border-strong);

      .action-group {
        border-inline-end: 1px solid var(--border-strong);

        .action {
          --goat-button-border-radius: 0;
        }
      }
    }

    .editor {
      flex: 1;
      overflow: auto;
      outline: none;
      padding-block: v(--spacing-03);
      padding-inline: v(--spacing-05);
      font-family: v(--body-01-font-family);
      font-size: v(--body-01-font-size);

      * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
      }
    }

    .editor .tiptap {
      outline: none;

      ul,
      ol {
        padding: 0 1rem;
        margin: 1.25rem 1rem 1.25rem 0.4rem;

        li p {
          margin-top: 0.25em;
          margin-bottom: 0.25em;
        }
      }

      .mention {
        background: var(--tag-background-primary);
        color: var(--tag-color-primary);
        padding: 0.1rem 0.25rem;
        border-radius: 12px;
      }

       p.is-editor-empty:first-child::before {
        color: #adb5bd;
        content: attr(data-placeholder);
        float: left;
        height: 0;
        pointer-events: none;
      }
      
    }
  }


  .html-code-editor {
    flex: 1;
    --code-editor-border: none;
    --code-editor-border-radius: 0;
  }

  .html-editor-footer {
    border-top: 1px solid var(--border-subtle);
    padding-block: v(--spacing-03);
    padding-inline: v(--spacing-05);
    display: flex;

    .footer-left {
      flex: 1;
    }
  }
}

:host([readonly]) .code-editor-component {
  cursor: initial;
  border-color: var(--border-subtle) !important;
  background-color: transparent !important;
  opacity: 1 !important;

  .tabs-list {
    border-top: 1px solid var(--border-subtle);
  }

  .wysiwyg-container {
    border-color: var(--border-subtle) !important;
    color: var(--text-primary) !important;
  }
}


:host([disabled]) .code-editor-component {
  cursor: not-allowed;
  border-color: var(--border-subtle) !important;
  background-color: var(--input-background-color, var(--field)) !important;

  opacity: 1 !important;

  .tabs-list {
    border-top: 1px solid var(--border-subtle);
  }

  .wysiwyg-container {
    border-color: var(--border-subtle) !important;
    color: var(--text-disabled) !important;
  }
}

.mention-menu {
  z-index: 1000;
  position: absolute;
  top: 0;
  visibility: hidden;
  pointer-events: none; 
  
  &.show {
    visibility: inherit;
    pointer-events: all;
  }
}

.hidden {
  display: none !important;
}

